import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { getRestaurantIdSchema } from 'forms/schemas';
import cache from 'utilities/cache';

export default function RestaurantSelect({ onUpdate }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [restaurantOptions, setRestaurantOptions] = useState([]);
  const [restaurantSelected, setRestaurantSelected] = useState();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const clientId = cache.get('app:facilityId');
      const restaurantIds = await getRestaurantIdSchema(null, null, clientId, false, false);
      const restaurantOptions = restaurantIds.enum.map((id, index) => ({
        id,
        name: restaurantIds.enumNames[index],
      }));
      setRestaurantOptions(restaurantOptions);
      setRestaurantSelected(restaurantOptions[0]);
      onUpdate && onUpdate(restaurantOptions[0]);
      setIsLoading(false);
    })();
  }, []);

  if (!restaurantSelected) {
    return <></>;
  }

  return (
    <Grid container spacing={1} alignContent='flex-end' alignItems='flex-end'>
      <Grid item xs={10}>
        <Autocomplete
          id={'restaurantSelect'}
          sx={{ width: 500 }}
          options={restaurantOptions}
          loading={isLoading}
          value={restaurantSelected}
          getOptionSelected={(option, value) => option.id === value.id}
          onChange={async (event, value = {})=> {
            if (!value) return;
            setRestaurantSelected(value);
          }}
          getOptionLabel={(option) => option.name}
          renderInput={(params) => (
            <TextField
              {...params}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {isLoading && <CircularProgress color="inherit" size={20} />}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
              InputLabelProps={{
                shrink: true,
              }}
              label={t('餐廳')}
              variant="standard"
            />
          )}
          noOptionsText='沒有符合所輸入的選項'
        />
      </Grid>
      <Grid item xs={2}>
        <Button
          variant="contained"
          color="primary"
          disabled={!restaurantSelected || !restaurantSelected.id}
          onClick={() => {
            onUpdate && onUpdate(restaurantSelected);
          }}
          fullWidth
        >
          更新
        </Button>
      </Grid>
    </Grid>);
}

RestaurantSelect.propTypes = {
  tagOptions: PropTypes.array,
  onUpdate: PropTypes.func,
  mode: PropTypes.string,
  data: PropTypes.object,
};
